import { render } from "./tempDetail.vue?vue&type=template&id=31b2f911&scoped=true&ts=true"
import script from "./tempDetail.vue?vue&type=script&lang=ts"
export * from "./tempDetail.vue?vue&type=script&lang=ts"

import "./tempDetail.vue?vue&type=style&index=0&id=31b2f911&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b2f911"]])

export default __exports__